<template>
<Form
	ref="form"
	class="m-0 p-0 g-0"
	@submit="onSubmit"
	@invalid-submit="console.log"
	:validation-schema="schema"
	:initial-values="formValues"
	v-slot="{ values, errors, meta, isSubmitting, }"
>
<fieldset class="" :disabled="!isFormEnabled">
	<div style="display: none;">
		{{ formMeta = meta }}
		{{ isSubmittingForm = isSubmitting }}
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 mt-1">
			<label class="fw-bold">
				Первинні налаштування
			</label>
		</div>
		
		<div class="col-12 col-xl-6 mt-1">
			<label>
				{{ ModemUnit.settingNames[ModemUnit.passportKeys.unitVersion] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.unitVersion"
				as="select"
				class="form-control form-control-sm"
				:class="{ 'is-invalid': errors[Station.passportKeys.modemUnit.unitVersion] }"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<template v-for="[key, value] of Object.entries(ModemUnit.versionNames)" :key="key">
					<option :value="key">{{ value }}</option>
				</template>
			</Field>
			<div class="invalid-feedback">
				{{ errors[Station.passportKeys.modemUnit.unitVersion] }}
			</div>
			<div v-if="accountStore.account.role === 'admin'" class="fst-italic cur-value-promt">
				{{ station.getMetric(ModemUnit.metricKeys.unitName)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6">
			<div class="bg-body border-radius px-3 py-2">
				<span class="form-text fst-italic">
					<b>Зверніть увагу</b><br>
					Для одномодульного модема налаштовується тільки модуль №1.
				</span>
			</div>
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ ModemUnit.settingNames[ModemUnit.passportKeys.unitPort] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.unitPort"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors[Station.passportKeys.modemUnit.unitPort] }"
			/>
			<div class="invalid-feedback">
				{{ errors[Station.passportKeys.modemUnit.unitPort] }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ ModemUnit.settingNames[ModemUnit.passportKeys.unitModbusAddr] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.unitModbusAddr"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors[Station.passportKeys.modemUnit.unitModbusAddr] }"
			/>
			<div class="invalid-feedback">
				{{ errors[Station.passportKeys.modemUnit.unitModbusAddr] }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<a :id="sections.module1.anchor" class="anchor-shift" />
	<span ref="module1Ref">
	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 mt-4">
			<label class="fw-bold">
				Налаштування модуля №1
			</label>
		</div>
		
		<div class="col-12 col-xl-6 mt-1">
			<label>
				{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.allowedGridMode1] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.allowedGridMode1"
				as="select"
				class="form-control form-control-sm"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.allowedGridMode1)"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<option v-for="mode in ModemUnit.allowedGridModeNames" :key="mode.code" :value="mode.code">{{ mode.title }}</option>
			</Field>
			<div class="invalid-feedback">
				{{ errors[Station.passportKeys.modemUnit.allowedGridMode1] }}
			</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.allowedGridMode1)"
				
			>
				Поточна мережа: 
				{{ ModemUnit.curentGridModeNames
					.filter((el) => el.code == station.getMetric(ModemUnit.metricKeys.gridMode_1)?.value)[0]
					?.title
				}}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-2">
			<label>
				{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.allowedServers1] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.allowedServers1"
				as="select"
				class="form-control form-control-sm"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.allowedServers1)"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<option v-for="mode in ModemUnit.serverNames" :key="mode.code" :value="mode.code">{{ mode.title }}</option>
			</Field>
			<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.allowedServers1]}}</div>
			<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.allowedServers1)">
				Поточне значення регістра:
				{{
					ModemUnit.serverNames
						.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.allowedServers1)?.value)
						?.title
				}}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-2">
			<label>
				{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.selfServerPort1] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.selfServerPort1"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.selfServerPort1)"
			/>
			<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.selfServerPort1]}}</div>
			<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.selfServerPort1)">
				Поточне значення регістра: 
				{{ station.getMetric(ModemUnit.metricKeys.selfServerPort1)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-2">
			<label>{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.server1Port1] }}</label>
			<Field
				:name="Station.passportKeys.modemUnit.server1Port1"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.server1Port1)"
			/>
			<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.server1Port1]}}</div>
			<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.server1Port1)">
				Поточне значення регістра: 
				{{ station.getMetric(ModemUnit.metricKeys.server1Port1)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-2">
			<label>{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.server2Port1] }}</label>
			<Field
				:name="Station.passportKeys.modemUnit.server2Port1"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.server2Port1)"
			/>
			<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.server2Port1]}}</div>
			<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.server2Port1)">
				Поточне значення регістра: 
				{{ station.getMetric(ModemUnit.metricKeys.server2Port1)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-2">
			<label>
				{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.forwardingAddr1] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.forwardingAddr1"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.forwardingAddr1)"
			/>
			<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.forwardingAddr1]}}</div>
			<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.forwardingAddr1)">
				Поточне значення регістра: 
				{{ station.getMetric(ModemUnit.metricKeys.forwardingAddr1)?.value }}
			</div>
			<div class="fst-italic cur-value-promt">
				0 - заборона прокидування,<br>255 - прокидувати всі адреси,<br>250 - зарезервовано
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-2">
			<div class="row row-cols-5 my-1 gap-0">
				<label class="col-12">
					{{ ModemUnit.settingNames['ip'] }}
				</label>
				<div class="col-3">
					<Field
						:name="Station.passportKeys.modemUnit.ip_1_octet_1"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.ip_1_octet_1)"
						style="min-width: 5rem;"
					/>
				</div>
				<div class="col-3">
					<Field
						:name="Station.passportKeys.modemUnit.ip_2_octet_1"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.ip_2_octet_1)"
						style="min-width: 5rem;"
					/>
				</div>
				<div class="col-3">
					<Field
						:name="Station.passportKeys.modemUnit.ip_3_octet_1"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.ip_3_octet_1)"
						style="min-width: 5rem;"
					/>
				</div>
				<div class="col-3">
					<Field
						:name="Station.passportKeys.modemUnit.ip_4_octet_1"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.ip_4_octet_1)"
						style="min-width: 5rem;"
					/>
				</div>
				<div class="col-12" style="font-size: 0.875em; color: #dc3545;">
					<span v-if="errors[Station.passportKeys.modemUnit.ip_1_octet_1]">{{errors[Station.passportKeys.modemUnit.ip_1_octet_1]}}</span>
					<span v-else-if="errors[Station.passportKeys.modemUnit.ip_2_octet_1]">{{errors[Station.passportKeys.modemUnit.ip_2_octet_1]}}</span>
					<span v-else-if="errors[Station.passportKeys.modemUnit.ip_3_octet_1]">{{errors[Station.passportKeys.modemUnit.ip_3_octet_1]}}</span>
					<span v-else-if="errors[Station.passportKeys.modemUnit.ip_4_octet_1]">{{errors[Station.passportKeys.modemUnit.ip_4_octet_1]}}</span>
				</div>
				<div
					class="col-12 fst-italic cur-value-promt"
					:class="ipRegisterValuesDynamicClasses(
						values,
						errors,
						[
							Station.passportKeys.modemUnit.ip_1_octet_1,
							Station.passportKeys.modemUnit.ip_2_octet_1,
							Station.passportKeys.modemUnit.ip_3_octet_1,
							Station.passportKeys.modemUnit.ip_4_octet_1,
						]
						)"
				>
					Поточне значення регістрів: 
					{{ station.getMetric(ModemUnit.metricKeys.ip_1_octet_1)?.value }}.{{ station.getMetric(ModemUnit.metricKeys.ip_2_octet_1)?.value }}.{{ station.getMetric(ModemUnit.metricKeys.ip_3_octet_1)?.value }}.{{ station.getMetric(ModemUnit.metricKeys.ip_4_octet_1)?.value }}
				</div>
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-2">
			<label>
				{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.serverPort1] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.serverPort1"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.serverPort1)"
			/>
			<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.serverPort1]}}</div>
			<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.serverPort1)">
				Поточне значення регістра: 
				{{ station.getMetric(ModemUnit.metricKeys.serverPort1)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-2">
			<label>
				{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.timeout1] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.timeout1"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.timeout1)"
			/>
			<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.timeout1]}}</div>
			<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.timeout1)">
				Поточне значення регістра: 
				{{ station.getMetric(ModemUnit.metricKeys.timeout1)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6">
			<div class="bg-body border-radius px-3 py-2">
				<span class="form-text fst-italic">
					Час очікування запитів від сервера перед відключенням. 0..60
				</span>
			</div>
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-2">
			<label>
				{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.apn1] }}
			</label>
			<Field
				:name="Station.passportKeys.modemUnit.apn1"
				type="text"
				class="form-control form-control-sm no-arrow"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.apn1)"
			/>
			<div class="invalid-feedback">
				{{ errors[Station.passportKeys.modemUnit.apn1] }}
			</div>
			<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.apn1)">
				Поточне значення регістра: 
				{{ station.getMetric(ModemUnit.metricKeys.apn1)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>
	</span>

	<template v-if="station.modem_unit.modulesCount == 2">
		<a :id="sections.module2.anchor" class="anchor-shift" />
		<span ref="module2Ref">
			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 mt-4">
					<label class="fw-bold">
						Налаштування модуля №2
					</label>
				</div>
				
				<div class="col-12 col-xl-6 mt-1">
					<label>
						{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.allowedGridMode1] }}
					</label>
					<Field
						:name="Station.passportKeys.modemUnit.allowedGridMode2"
						as="select"
						class="form-control form-control-sm"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.allowedGridMode2)"
					>
						<option value="" disabled>Натисніть щоб обрати</option>
						<option v-for="mode in ModemUnit.allowedGridModeNames" :key="mode.code" :value="mode.code">{{ mode.title }}</option>
					</Field>
					<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.allowedGridMode2]}}</div>
					<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.allowedGridMode2)">
						Поточна мережа: 
						{{ ModemUnit.curentGridModeNames
							.filter((el) => el.code == station.getMetric(ModemUnit.metricKeys.gridMode_2)?.value)[0]
							?.title
						}}
					</div>
				</div>

				<div class="col-12 col-xl-6 d-none d-xl-block">
					&nbsp;
				</div>
			</div>

			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 col-xl-6 mt-2">
					<label>
						{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.allowedServers2] }}
					</label>
					<Field
						:name="Station.passportKeys.modemUnit.allowedServers2"
						as="select"
						class="form-control form-control-sm"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.allowedServers2)"
					>
						<option value="" disabled>Натисніть щоб обрати</option>
						<option v-for="mode in ModemUnit.serverNames" :key="mode.code" :value="mode.code">{{ mode.title }}</option>
					</Field>
					<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.allowedServers2]}}</div>
					<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.allowedServers2)">
						Поточне значення регістра: 
						{{
							ModemUnit.serverNames
								.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.allowedServers2)?.value)
								?.title
						}}
					</div>
				</div>

				<div class="col-12 col-xl-6 d-none d-xl-block">
					&nbsp;
				</div>
			</div>

			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 col-xl-6 mt-2">
					<label>
						{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.selfServerPort2] }}
					</label>
					<Field
						:name="Station.passportKeys.modemUnit.selfServerPort2"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.selfServerPort2)"
					/>
					<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.selfServerPort2]}}</div>
					<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.selfServerPort2)">
						Поточне значення регістра: 
						{{ station.getMetric(ModemUnit.metricKeys.selfServerPort2)?.value }}
					</div>
				</div>

				<div class="col-12 col-xl-6 d-none d-xl-block">
					&nbsp;
				</div>
			</div>

			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 col-xl-6 mt-2">
					<label>
						{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.server1Port2] }}
					</label>
					<Field
						:name="Station.passportKeys.modemUnit.server1Port2"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.server1Port2)"
					/>
					<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.server1Port2]}}</div>
					<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.server1Port2)">
						Поточне значення регістра: 
						{{ station.getMetric(ModemUnit.metricKeys.server1Port2)?.value }}
					</div>
				</div>

				<div class="col-12 col-xl-6 d-none d-xl-block">
					&nbsp;
				</div>
			</div>

			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 col-xl-6 mt-2">
					<label>
						{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.server2Port2] }}
					</label>
					<Field
						:name="Station.passportKeys.modemUnit.server2Port2"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.server2Port2)"
					/>
					<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.server2Port2]}}</div>
					<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.server2Port2)">
						Поточне значення регістра: 
						{{ station.getMetric(ModemUnit.metricKeys.server2Port2)?.value }}
					</div>
				</div>

				<div class="col-12 col-xl-6 d-none d-xl-block">
					&nbsp;
				</div>
			</div>

			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 col-xl-6 mt-2">
					<label>
						{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.forwardingAddr2] }}
					</label>
					<Field
						:name="Station.passportKeys.modemUnit.forwardingAddr2"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.forwardingAddr2)"
					/>
					<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.forwardingAddr2]}}</div>
					<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.forwardingAddr2)">
						Поточне значення регістра: 
						{{ station.getMetric(ModemUnit.metricKeys.forwardingAddr2)?.value }}
					</div>
					<div class="fst-italic cur-value-promt">
						0 - заборона прокидування,<br>255 - прокидувати всі адреси,<br>250 - зарезервовано
					</div>
				</div>

				<div class="col-12 col-xl-6 d-none d-xl-block">
					&nbsp;
				</div>
			</div>

			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 col-xl-6 mt-2">
					<div class="row row-cols-5 my-1 gap-0">
						<label class="col-12">{{ ModemUnit.settingNames['ip'] }}</label>
						<div class="col-3">
							<Field
								:name="Station.passportKeys.modemUnit.ip_1_octet_2"
								type="number"
								class="form-control form-control-sm no-arrow"
								:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.ip_1_octet_2)"
								style="min-width: 5rem;"
							/>
						</div>
						<div class="col-3">
							<Field
								:name="Station.passportKeys.modemUnit.ip_2_octet_2"
								type="number"
								class="form-control form-control-sm no-arrow"
								:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.ip_2_octet_2)"
								style="min-width: 5rem;"
							/>
						</div>
						<div class="col-3">
							<Field
								:name="Station.passportKeys.modemUnit.ip_3_octet_2"
								type="number"
								class="form-control form-control-sm no-arrow"
								:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.ip_3_octet_2)"
								style="min-width: 5rem;"
							/>
						</div>
						<div class="col-3">
							<Field
								:name="Station.passportKeys.modemUnit.ip_4_octet_2"
								type="number"
								class="form-control form-control-sm no-arrow"
								:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.ip_4_octet_2)"
								style="min-width: 5rem;"
							/>
						</div>
						<div class="col-12" style="font-size: 0.875em; color: #dc3545;">
							<span v-if="errors[Station.passportKeys.modemUnit.ip_1_octet_2]">{{errors[Station.passportKeys.modemUnit.ip_1_octet_2]}}</span>
							<span v-else-if="errors[Station.passportKeys.modemUnit.ip_2_octet_2]">{{errors[Station.passportKeys.modemUnit.ip_2_octet_2]}}</span>
							<span v-else-if="errors[Station.passportKeys.modemUnit.ip_3_octet_2]">{{errors[Station.passportKeys.modemUnit.ip_3_octet_2]}}</span>
							<span v-else-if="errors[Station.passportKeys.modemUnit.ip_4_octet_2]">{{errors[Station.passportKeys.modemUnit.ip_4_octet_2]}}</span>
						</div>
						<div
							class="col-12 fst-italic cur-value-promt"
							:class="ipRegisterValuesDynamicClasses(
								values,
								errors,
								[
									Station.passportKeys.modemUnit.ip_1_octet_2,
									Station.passportKeys.modemUnit.ip_2_octet_2,
									Station.passportKeys.modemUnit.ip_3_octet_2,
									Station.passportKeys.modemUnit.ip_4_octet_2,
								]
								)"
							
						>
							Поточне значення регістрів: 
							{{ station.getMetric(ModemUnit.metricKeys.ip_1_octet_2)?.value }}.{{ station.getMetric(ModemUnit.metricKeys.ip_2_octet_2)?.value }}.{{ station.getMetric(ModemUnit.metricKeys.ip_3_octet_2)?.value }}.{{ station.getMetric(ModemUnit.metricKeys.ip_4_octet_2)?.value }}
						</div>
					</div>
				</div>

				<div class="col-12 col-xl-6 d-none d-xl-block">
					&nbsp;
				</div>
			</div>

			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 col-xl-6 mt-2">
					<label>
						{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.serverPort2] }}
					</label>
					<Field
						:name="Station.passportKeys.modemUnit.serverPort2"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.serverPort2)"
					/>
					<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.serverPort2]}}</div>
					<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.serverPort2)">
						Поточне значення регістра: 
						{{ station.getMetric(ModemUnit.metricKeys.serverPort2)?.value }}
					</div>
				</div>

				<div class="col-12 col-xl-6 d-none d-xl-block">
					&nbsp;
				</div>
			</div>

			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 col-xl-6 mt-2">
					<label>
						{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.timeout2] }}
					</label>
					<Field
						:name="Station.passportKeys.modemUnit.timeout2"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.timeout2)"
					/>
					<div class="invalid-feedback">{{errors[Station.passportKeys.modemUnit.timeout2]}}</div>
					<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.timeout2)">
						Поточне значення регістра: 
						{{ station.getMetric(ModemUnit.metricKeys.timeout2)?.value }}
					</div>
				</div>

				<div class="col-12 col-xl-6">
					<div class="bg-body border-radius px-3 py-2">
						<span class="form-text fst-italic">
							Час очікування запитів від сервера перед відключенням. 0..60
						</span>
					</div>
				</div>
			</div>

			<div class="form-row row m-0 p-0 g-3">
				<div class="col-12 col-xl-6 mt-2">
					<label>
						{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.apn2] }}
					</label>
					<Field
						:name="Station.passportKeys.modemUnit.apn2"
						type="text"
						class="form-control form-control-sm no-arrow"
						:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.apn2)"
					/>
					<div class="invalid-feedback">
						{{ errors[Station.passportKeys.modemUnit.apn2] }}
					</div>
					<div class="fst-italic cur-value-promt" :class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.apn2)">
						Поточне значення регістра: 
						{{ station.getMetric(ModemUnit.metricKeys.apn2)?.value }}
					</div>
				</div>

				<div class="col-12 col-xl-6 d-none d-xl-block">
					&nbsp;
				</div>
			</div>
		</span>
	</template>

	<!-- Port 1 settings -->
	<a :id="sections.port1.anchor" class="anchor-shift" />
	<span ref="port1Ref">
		<div class="form-row row m-0 p-0 g-3">
			<div class="col-12 mt-4">
				<label class="fw-bold">
					Налаштування першого порта RS485
				</label>
			</div>

			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.speed1] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.speed1"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.speed1)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.portSpeedModeNames"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.speed1] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.speed1)"
				>
					Поточне значення регістра: 
					<!-- {{ station.getMetric(ModemUnit.metricKeys.speed1)?.value }} -->
					{{ ModemUnit.portSpeedModeNames.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.speed1)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6 d-none d-xl-block">
				&nbsp;
			</div>
		</div>

		<div class="form-row row m-0 p-0 g-3">
			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.bitCount1] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.bitCount1"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.bitCount1)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.dataBitsCountNames"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.bitCount1] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.bitCount1)"
				>
					Поточне значення регістра: 
					{{ ModemUnit.dataBitsCountNames.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.bitCount1)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6 d-none d-xl-block">
				&nbsp;
			</div>
		</div>

		<div class="form-row row m-0 p-0 g-3">
			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.stopBit1] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.stopBit1"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.stopBit1)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.stopBitsCountNames"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.stopBit1] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.stopBit1)"
				>
					Поточне значення регістра: 
					{{ ModemUnit.stopBitsCountNames.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.stopBit1)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6 d-none d-xl-block">
				&nbsp;
			</div>
		</div>

		<div class="form-row row m-0 p-0 g-3">
			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.parity1] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.parity1"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.parity1)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.parityNames"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.parity1] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.parity1)"
				>
					Поточне значення регістра: 
					{{ ModemUnit.parityNames.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.parity1)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6 d-none d-xl-block">
				&nbsp;
			</div>
		</div>

		<div
			v-if="station.getMetric(ModemUnit.metricKeys.convertingRtu1)"
			class="form-row row m-0 p-0 g-3"
		>
			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.convertingRtu1] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.convertingRtu1"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.convertingRtu1)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.rtuModeNames"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.convertingRtu1] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.convertingRtu1)"
				>
					Поточне значення регістра: 
					{{ ModemUnit.rtuModeNames.find((el) => el.code === station.getMetric(ModemUnit.metricKeys.convertingRtu1)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6">
				<div class="bg-body border-radius px-3 py-2">
					<span class="form-text fst-italic">
						При <b>викненому</b> конвертуванні порт працює в режимі ModBus RTU over TCP: 
						ModBus RTU пакет інкапсулюється в TCP/IP пакет як є.<br>
						При <b>ввімкненому</b> конвертуванні порт працює в режимі ModBus TCP: 
						в TCP/IP пакеті інкапсульовано ModBus RTU пакет без контрольної суми і з додатковим MBAP заголовком.<br>
						<b>*</b> силовий модуль версії "В-ОПЕК" є несумісним з увімкненим конвертуванням.
					</span>
				</div>
			</div>
		</div>
	</span>

	<!-- Port 2 settings -->
	<a :id="sections.port2.anchor" class="anchor-shift" />
	<span ref="port2Ref">
		<div class="form-row row m-0 p-0 g-3">
			<div class="col-12 mt-4">
				<label class="fw-bold">
					Налаштування другого порта RS485
				</label>
			</div>

			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.speed2] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.speed2"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.speed2)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.portSpeedModeNames"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.speed2] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.speed2)"
				>
					Поточне значення регістра: 
					{{ ModemUnit.portSpeedModeNames.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.speed2)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6 d-none d-xl-block">
				&nbsp;
			</div>
		</div>

		<div class="form-row row m-0 p-0 g-3">
			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.bitCount2] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.bitCount2"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.bitCount2)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.dataBitsCountNames				"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.bitCount2] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.bitCount2)"
				>
					Поточне значення регістра: 
					{{ ModemUnit.dataBitsCountNames.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.bitCount2)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6 d-none d-xl-block">
				&nbsp;
			</div>
		</div>

		<div class="form-row row m-0 p-0 g-3">
			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.stopBit2] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.stopBit2"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.stopBit2)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.stopBitsCountNames"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.stopBit2] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.stopBit2)"
				>
					Поточне значення регістра: 
					{{ ModemUnit.stopBitsCountNames.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.stopBit2)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6 d-none d-xl-block">
				&nbsp;
			</div>
		</div>

		<div class="form-row row m-0 p-0 g-3">
			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.parity2] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.parity2"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.parity2)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.parityNames"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.parity2] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.parity2)"
				>
					Поточне значення регістра: 
					{{ ModemUnit.parityNames.find((el) => el.code == station.getMetric(ModemUnit.metricKeys.parity2)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6 d-none d-xl-block">
				&nbsp;
			</div>
		</div>

		<div
			v-if="station.getMetric(ModemUnit.metricKeys.convertingRtu2)"
			class="form-row row m-0 p-0 g-3"
		>
			<div class="col-12 col-xl-6 mt-2">
				<label>
					{{ ModemUnit.settingNames[Station.passportKeys.modemUnit.convertingRtu2] }}
				</label>
				<Field
					:name="Station.passportKeys.modemUnit.convertingRtu2"
					as="select"
					class="form-control form-control-sm"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.convertingRtu2)"
				>
					<option value="" disabled>Натисніть щоб обрати</option>
					<option
						v-for="mode in ModemUnit.rtuModeNames"
						:key="mode.code"
						:value="mode.code"
					>
						{{ mode.title }}
					</option>
				</Field>
				<div class="invalid-feedback">
					{{ errors[Station.passportKeys.modemUnit.convertingRtu2] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Station.passportKeys.modemUnit.convertingRtu2)"
				>
					Поточне значення регістра: 
					{{ ModemUnit.rtuModeNames.find((el) => el.code === station.getMetric(ModemUnit.metricKeys.convertingRtu2)?.value)?.title }}
				</div>
			</div>

			<div class="col-12 col-xl-6">
				<div class="bg-body border-radius px-3 py-2">
					<span class="form-text fst-italic">
						При <b>викненому</b> конвертуванні порт працює в режимі ModBus RTU over TCP: 
						ModBus RTU пакет інкапсулюється в TCP/IP пакет як є.<br>
						При <b>ввімкненому</b> конвертуванні порт працює в режимі ModBus TCP: 
						в TCP/IP пакеті інкапсульовано ModBus RTU пакет без контрольної суми і з додатковим MBAP заголовком.<br>
						<b>*</b> силовий модуль версії "В-ОПЕК" є несумісним з увімкненим конвертуванням.
					</span>
				</div>
			</div>
		</div>
	</span>

	<!-- Set setting register task state -->
	<div class="form-row row row-cols-1 m-0 p-0 mt-2">
		<dl v-if="relatedRpc" class="mb-1 text-dark">
			<dt>Останній запит запису регістрів</dt>
			<dd class="mb-0 ms-3">
				Відправив: <span class="font-monospace">{{ relatedRpc.context?.writer?.name }}</span>
				<span v-if="relatedRpc.context?.writer?.organization?.name" class="font-monospace">&nbsp;({{ relatedRpc.context?.writer?.organization?.name }})</span>
			</dd>
			<dd class="mb-0 ms-3">
				Час: <span class="font-monospace">{{ dateTimeToString(relatedRpc[rpcTaskSchema.updateTime.key], false, false, true) }}</span>
			</dd>
			<dd class="mb-0 ms-3">
				Стан: <span
					class="font-monospace"
					:class="{
						'text-danger': rpcTaskSchema.state.isErorrState(relatedRpc?.state),
						'text-success': !rpcTaskSchema.state.isErorrState(relatedRpc?.state),
					}"
				>
					{{ taskStateDescription(relatedRpc?.state) }}
				</span>
			</dd>
			<!-- {{relatedRpc?._id}} -->
		</dl>
	</div>

	<div class="row row-cols-1 m-0 p-0 my-3">
		<div class="col-12 my-0">
			<p v-if="feedbackPromt.length > 0" class="m-0" :class="feedbackPromtClass">
				{{ feedbackPromt }}
			</p>
			<p v-else-if="meta.dirty && meta.valid" class="text-success m-0">
				Натисніть "Зберегти" щоб примінити налаштування.
			</p>
			<p v-else-if="meta.dirty && !meta.valid" class="text-danger m-0">
				Є поля що заповнені некоректно.
			</p>
			<p v-else class="m-0">&nbsp;</p>
		</div>
	</div>

	<div class="row row-cols-1 form-row m-0 p-0 mb-2">
		<div class="col-12 my-0 mt-1">
			<button
				ref="submitButtonRef"
				type="submit"
				class="btn btn-primary btn-sm"
				:disabled="!meta.valid || !meta.dirty || isSubmitting"
			>
				Записати
			</button>
		</div>
	</div>
</fieldset>
</Form>
</template>




<script>
import { useStationsStore } from '@/stores/StationsStore.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { rpcTaskSchema, useRpcTasks, } from '@/composables/rpcTasks.js'
// Validation
// https://jasonwatmore.com/post/2020/10/01/vue-3-veevalidate-form-validation-example
import { Form, Field } from 'vee-validate'
// https://github.com/jquense/yup/tree/a58f02d2f6164c46a9757a818eebac582f7a441c#boolean
import * as Yup from 'yup';

import { Station } from '@/models/station.js'
import { ModemUnit } from '@/models/modemUnit.js'
import {
	capitalizeFirstLetter,
	dateTimeToString,
	getObjectDiff,
} from '@/helpers.js'


export default {
	requiredPromt: 'Обов\'язкове поле',
	overMinLenPromt: 'Довжина меньше мінімальної',
	overMaxLenPromt: 'Довжина більше максимальної',
	overMinPromt: 'Значення меньше мінімального',
	overMaxPromt: 'Значення більше максимального',
	onlyIntegersPromt: 'Має бути цілим числом',
	onlyPositivePromt: 'Має бути натуральним числом',
	wrongInputPromt: 'Не відповідає вимогам',

	components: {
		Form,
        Field,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	emits: {
		rpc: (promt) => typeof promt === 'object',
		sections: (s) => typeof s === "object",
		saveFunction: (f) => typeof f === 'function',
		saveFunctionActive: (f) => typeof f === 'boolean',
	},

	setup() {
		const stationsStore = useStationsStore()
		const accountStore = useAccontStore()
		const { createRpc, readRpc, } = useRpcTasks()

		return {
			stationsStore,
			accountStore,
			Station,
			ModemUnit,
			rpcTaskSchema,
			capitalizeFirstLetter,
			dateTimeToString,
			createRpc,
			readRpc,
		}
	},

	data() {
		const schema = Yup.object().shape({
			modem_unit:  Yup.object().shape({
				unit_version: Yup.string()
					.typeError(this.$options.wrongInputPromt),
					//.required(this.$options.requiredPromt),
				unit_port: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt)
					// Port is required only when modem unit is present
					.when('unit_version', {
						is: (val) => val == ModemUnit.versions.unknown || val == undefined,
						//then: (schema) => schema,
						otherwise: (schema) => schema.required(this.$options.requiredPromt),
					}),
				unit_modbus_addr: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt)
					// ModBus address is required only when service unit is present
					.when('unit_version', {
						is: (val) => val == ModemUnit.versions.unknown || val == undefined,
						//then: (schema) => schema,
						otherwise: (schema) => schema.required(this.$options.requiredPromt),
					}),
				allowed_grid_mode_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(6, this.$options.overMaxPromt),
				allowed_grid_mode_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(6, this.$options.overMaxPromt),
				allowed_servers_1:  Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(3, this.$options.overMaxPromt),
				allowed_servers_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(3, this.$options.overMaxPromt),
				self_server_port_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				server_1_port_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				server_2_port_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				self_server_port_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				server_1_port_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				server_2_port_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				forwarding_addr_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt)
					.notOneOf([250,], '250 заборонено'),
				forwarding_addr_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt)
					.notOneOf([250,], '250 заборонено'),
				ip_1_octet_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
				ip_2_octet_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
				ip_3_octet_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
				ip_4_octet_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
				server_port_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				ip_1_octet_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
				ip_2_octet_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
				ip_3_octet_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
				ip_4_octet_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
				server_port_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				timeout_1: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(60, this.$options.overMaxPromt),
				timeout_2: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(0, this.$options.overMinPromt)
					.max(60, this.$options.overMaxPromt),
				[Station.passportKeys.modemUnit.speed1]: Yup.number(),
				[Station.passportKeys.modemUnit.speed2]: Yup.number(),
				[Station.passportKeys.modemUnit.bitCount1]: Yup.number(),
				[Station.passportKeys.modemUnit.bitCount2]: Yup.number(),
				[Station.passportKeys.modemUnit.stopBit1]: Yup.number(),
				[Station.passportKeys.modemUnit.stopBit2]: Yup.number(),
				[Station.passportKeys.modemUnit.parity1]: Yup.number(),
				[Station.passportKeys.modemUnit.parity2]: Yup.number(),
				[Station.passportKeys.modemUnit.convertingRtu1]: Yup.number(),
				[Station.passportKeys.modemUnit.convertingRtu2]: Yup.number(),
				[Station.passportKeys.modemUnit.apn1]: Yup.string()
					.typeError(this.$options.wrongInputPromt)
					.notRequired()
					.nullable()
					.min(0, this.$options.overMinLenPromt)
					.transform((value) => (value ? value : undefined)) // if empty string
					.max(30, this.$options.overMaxLenPromt),
				[Station.passportKeys.modemUnit.apn2]: Yup.string()
					.typeError(this.$options.wrongInputPromt)
					.notRequired()
					.nullable()
					.min(0, this.$options.overMinLenPromt)
					.transform((value) => (value ? value : undefined)) // if empty string
					.max(30, this.$options.overMaxLenPromt),
			})
		})

		return {
			// Form
			schema,
			formMeta: {},
			isSubmittingForm: false,

			relatedRpc: undefined,
			rpcUpdateInterval: null,

			observer: null, // IntersectionObserver

			sections: {
				module1: {
					anchor: 'modem-module-1',
					title: 'Модуль №1',
					intersectionRatio: 0, // 0 .. 1
				},
				module2: {
					anchor: 'modem-module-2',
					title: 'Модуль №2',
					intersectionRatio: 0, // 0 .. 1
				},
				port1: {
					anchor: 'modem-port-1',
					title: 'Порт RS485 №1',
					intersectionRatio: 0, // 0 .. 1
				},
				port2: {
					anchor: 'modem-port-2',
					title: 'Порт RS485 №2',
					intersectionRatio: 0, // 0 .. 1
				},
			},

			// Feedback promt
			feedbackPromtClass: '',
			feedbackPromt: '',
		}
	},

	watch: {
		formMeta(newMeta) {
			if (newMeta) {
				this.$emit('saveFunctionActive', newMeta.valid && newMeta.dirty && !this.isSubmittingForm);
				// console.log('meta change', newMeta, !newMeta.valid || !newMeta.dirty || this.isSubmittingForm)
			}
		},
	},

	created() {
		this.readRelatedRpc()
	},

	mounted() {
		// Emit function
		this.$emit('saveFunction', this.submitButtonClick)

		// Add observer for viewport area feedback
		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					switch (entry.target) {
						case this.$refs.module1Ref:
							this.sections.module1.intersectionRatio = entry.intersectionRatio
							break
						case this.$refs.module2Ref:
							this.sections.module2.intersectionRatio = entry.intersectionRatio
							break
						case this.$refs.port1Ref:
							this.sections.port1.intersectionRatio = entry.intersectionRatio
							break
						case this.$refs.port2Ref:
							this.sections.port2.intersectionRatio = entry.intersectionRatio
							break
					}
				})
			},
			{
				root: null, // null means all viewport
				rootMargin: '0px',
				threshold: [0, 0.5, 1] // callback call trasholds 0%, 50% and 100% viewport
			}
		)

		if (this.station.modem_unit.modulesCount == 1) {
			delete this.sections.module2

			this.observer.observe(this.$refs.module1Ref)
		} else {
			this.observer.observe(this.$refs.module1Ref)
			this.observer.observe(this.$refs.module2Ref)
		}

		this.observer.observe(this.$refs.port1Ref)
		this.observer.observe(this.$refs.port2Ref)

		this.$emit('sections', this.sections)
	},

	methods: {
		fieldDynamicClasses(values, errors, valueKey) {
			const isInvalid = errors[valueKey]
			const isMatchRegister = (values ? values[valueKey] : undefined) == this.station.getMetric(valueKey)?.value

			return {
				'is-invalid': isInvalid,
				'not-match-register': !isMatchRegister && !isInvalid,
			}
		},

		ipRegisterValuesDynamicClasses(values, errors, valueKeys) {
			const isInvalid = []
			const isMatchRegisters = []
			
			for (const key of valueKeys) {
				isInvalid.push(errors[key])
				isMatchRegisters.push(
					(values ? values[key] : undefined) == this.station.getMetric(key)?.value
				)
			}

			return {
				'not-match-register':
					isMatchRegisters.some(reg => reg == false) && isInvalid.every(reg => (reg == false || reg == undefined)),
			}
		},

		async readRelatedRpc() {
			if (this.relatedRpcId == undefined) {
				return
			}

			this.relatedRpc = await this.readRpc(this.relatedRpcId)

			this.$emit('rpc', this.relatedRpc)
		},

		async onSubmit(values) {
			let settingsWriteResult = false
			let relatedRpcId = undefined

			// Keys that need to be write to registers
			const settingsKeys = new Set([
				Station.passportKeys.modemUnit.allowedGridMode1,
				Station.passportKeys.modemUnit.allowedGridMode2,
				Station.passportKeys.modemUnit.allowedServers1,
				Station.passportKeys.modemUnit.allowedServers2,
				Station.passportKeys.modemUnit.selfServerPort1,
				Station.passportKeys.modemUnit.server1Port1,
				Station.passportKeys.modemUnit.server2Port1,
				Station.passportKeys.modemUnit.selfServerPort2,
				Station.passportKeys.modemUnit.server1Port2,
				Station.passportKeys.modemUnit.server2Port2,
				Station.passportKeys.modemUnit.forwardingAddr1,
				Station.passportKeys.modemUnit.forwardingAddr2,
				Station.passportKeys.modemUnit.ip_1_octet_1,
				Station.passportKeys.modemUnit.ip_2_octet_1,
				Station.passportKeys.modemUnit.ip_3_octet_1,
				Station.passportKeys.modemUnit.ip_4_octet_1,
				Station.passportKeys.modemUnit.serverPort1,
				Station.passportKeys.modemUnit.ip_1_octet_2,
				Station.passportKeys.modemUnit.ip_2_octet_2,
				Station.passportKeys.modemUnit.ip_3_octet_2,
				Station.passportKeys.modemUnit.ip_4_octet_2,
				Station.passportKeys.modemUnit.serverPort2,
				Station.passportKeys.modemUnit.timeout1,
				Station.passportKeys.modemUnit.timeout2,
				Station.passportKeys.modemUnit.speed1,
				Station.passportKeys.modemUnit.speed2,
				Station.passportKeys.modemUnit.bitCount1,
				Station.passportKeys.modemUnit.bitCount2,
				Station.passportKeys.modemUnit.stopBit1,
				Station.passportKeys.modemUnit.stopBit2,
				Station.passportKeys.modemUnit.parity1,
				Station.passportKeys.modemUnit.parity2,
				Station.passportKeys.modemUnit.convertingRtu1,
				Station.passportKeys.modemUnit.convertingRtu2,
				Station.passportKeys.modemUnit.apn1,
				Station.passportKeys.modemUnit.apn2,
			])

			// Found changed values in settings
			const diff = getObjectDiff(
				this.formValues,
				values,
			)
			let changedSettings = new Set()
			if (diff !== null) {
				const changedKeys = new Set(Object.keys(diff))
				changedSettings = settingsKeys.intersection(changedKeys)
			}
			
			// If there is any changes in settings		
			if (changedSettings.size > 0) {
				// Set changed settings to payload Object
				const payload = {}
				for (const setting of changedSettings) {
					payload[setting] = values[setting]
				}

				// Submit settings to server
				relatedRpcId = await this.submitSettings(payload)
				settingsWriteResult = relatedRpcId === false ? false : true
			} else {
				settingsWriteResult = true
			}

			if (settingsWriteResult) {
				// Submit passport to server
				this.submitPassport(values, relatedRpcId)
			}

			return settingsWriteResult
		},

		submitPassport(values, relatedRpcId=undefined) {
			//console.log("values", values)
			const payload = { [Station.passportKeys.modemUnit.self]: { ...values } }
			payload[Station.passportKeys.updateBy] = this.accountStore.userId

			// Save rpc id
			if (relatedRpcId) {
				payload[Station.passportKeys.modemUnit.self][Station.passportKeys.modemUnit.relatedRpc] = relatedRpcId
			}

			this.stationsStore.updatePasport(
				(result) => {
					if (result) {
						this.printHint('Паспорт успішно оновлено.', 'passport')
						// Update passport
						this.stationsStore.readPassport(undefined, this.stationId)
						// Update rpc with period
						this.rpcUpdateInterval = setInterval(async () => {
							this.readRelatedRpc()
						}, 1000)
					} else {
						this.printErr('Сервер відхилив запит.', 'passport')
					}
				},
				this.stationId,
				payload
			)
		},

		async submitSettings(values) {
			// console.log("Submit settings", values)

			if (this.relatedRpc?.complete === false) {
				this.printErr(
					`Станція вже обробляє інший запит (${rpcTaskSchema.job.findJob(this.relatedRpc.job).title}). `
					+'Будь ласка дочекайтесь його виконання.'
				)
				return false
			} else if (!this.station.isActive) {
				this.printErr('Станція не активна. Тільки активні станції виконують запити.')
				return false
			} else if (this.relatedRpc === undefined
				|| this.relatedRpc.complete === true
			) {
				return await this.writeRpc(values)
			} else {
				this.printErr('Сталася невідома помилка')
				return false
			}
		},

		async writeRpc(values) {
			const context = {}

			delete values[Station.passportKeys.modemUnit.unitVersion]
			delete values[Station.passportKeys.modemUnit.unitPort]
			delete values[Station.passportKeys.modemUnit.unitModbusAddr]
			delete values[Station.passportKeys.modemUnit.relatedRpc]

			context.settings = values
			
			context.unit = Station.passportKeys.modemUnit.self
			context.writer = {
				"name": this.accountStore.userName,
				"id": this.accountStore.userId,
				"organization": {
					"name": this.accountStore.organization["title"],
					"id": this.accountStore.organization["_id"],
				},
			}

			return await this.createRpc(
				this.accountStore.userId,
				rpcTaskSchema.job.allowed.setUnitRegisters.key,
				this.stationId,
				null,
				context,
			).then((result) => {
				if (result) {
					this.printHint('Запит надіслано. Спостерігайте за його станом.')
				} else {
					this.printErr('Сервер відхилив запит постановки завдання.', 'settings')
				}

				return result
			})
		},

		submitButtonClick() {
			this.$refs.submitButtonRef.click()
		},

		printHint (msg) {
			this.feedbackPromtClass = "text-success"
			this.feedbackPromt = msg
		},

		printErr (msg) {
			this.feedbackPromtClass = "text-danger"
			this.feedbackPromt = msg
		},

		taskStateDescription(state) {
			const stateObj = this.rpcTaskSchema.state.findState(state)
			return stateObj == undefined || stateObj == false
				? "невизначено"
				: stateObj.title
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		isFormEnabled() { return this.accountStore.permissions.includes('manage_stations') },

		formValues() {
			return { ...this.station?.passport.get(Station.passportKeys.modemUnit.self) }
		},

		relatedRpcId() {
			const modemPassport = this.station.passport.get(Station.passportKeys.modemUnit.self)
			return modemPassport ? modemPassport[Station.passportKeys.modemUnit.relatedRpc] : undefined
		},
	},

	beforeUnmount() {
		if (this.rpcUpdateInterval != null) {
			clearInterval(this.rpcUpdateInterval)
			this.rpcUpdateInterval = null
		}

		// If observer, then disable
		if (this.observer) {
			this.observer.disconnect()
		}
	},
}
</script>




<style scoped>
/* Remove arrows from input Chrome, Safari, Edge, Opera */
input.no-arrow::-webkit-outer-spin-button,
input.no-arrow::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove arrows from input Firefox */
input[type=number].no-arrow {
	appearance: textfield;
	-moz-appearance: textfield;
}

/* Style for input if it is not match register value */
.not-match-register {
	border-color: rgb(11, 94, 215);
	color: rgb(11, 94, 215);
}

.cur-value-promt {
	font-size: 0.875em;
}

.anchor-shift {
	position: relative;
	/* top: calc(v-bind(headerHeight) * -1); */
	top: -10px;
}
</style>